import React from "react";

import CreateSuspendedComponent from "containers/app/CreateSuspendedComponent";

const Component = CreateSuspendedComponent(() => import("./HomeContainer"));

const HomeContainer: React.FC<{}> = () => {
  return <Component />;
};

export default HomeContainer;
